import React, { useContext, useEffect } from "react";
import { useState } from "react";
import axios from "axios";
import { NavLink, useNavigate } from "react-router-dom";
import withRouter from "../../Utils/withRouter";
import { ConfigContext } from "../../Context/ConfigContext";

const ForgotPassword = () => {
  const { apiURL } = useContext(ConfigContext);
  const [username, setUsername] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();


  const handleUsernameChange = (event) => {
    setUsername(event.target.value);
  };
  useEffect(() => {
    setErrorMessage("");
  }, [username]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);


    try {
      const response = await axios.post(`${apiURL}User/ForgotPassword?user_name=${username}`);
      setIsLoading(false);
      const data = response.data;
      console.log(`data`, data);
      if (data.success === true) {
        setUsername("");
        navigate('/OtpVerification');
        return;
      } else if (data.email_err === true && data.success === false) {
        navigate('/EmailNotFound');
        setIsLoading(false);
        return;
      } else if (data.email_err === false && data.success === false) {
        setErrorMessage(data.message);
        setIsLoading(false);
      }
    } catch (error) {
      console.log(`error`, error);
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="auth-page-wrapper">

        <div className="auth-one-bg-position auth-one-bg" id="auth-particles">
          <div className="bg-overlay "></div>

          <div className="shape">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 1440 120"
            >
              <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
            </svg>
          </div>
        </div>
      </div>

      <div className="auth-page-content">
        <div style={{ height: "89vh"}} className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center mt-sm-5 mb-4 text-white">
                <div className="d-inline-block auth-logo">
                </div>
                <p className="mt-3 fs-15 fw-bolder"></p>
              </div>
            </div>
          </div>


          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6 col-xl-5">
              <div className="card mt-3">
                <div className="card-body rounded-3 position-absolute w-100 bg-white z-1 p-4">
                  <div className="text-center">
                    <h5 className="text-primary">Forgot Password</h5>
                    {/* <p className="text-muted">Reset password with AbStart</p> */}
                    <lord-icon src="https://cdn.lordicon.com/rhvddzym.json" trigger="loop" colors="primary:#0ab39c" classname="avatar-xl fs-4" style={{ width: '6rem', height: '6rem' }} />

                  </div>
                  {errorMessage ? (
                    <div className="alert border-0 alert-danger text-center mb-2 mx-2" role="alert">
                      {errorMessage}</div>
                  ) : (
                    <div className="alert border-0 alert-warning text-center mb-2 mx-2" role="alert">
                      Enter your username and instructions will be sent to you!
                    </div>
                  )}
                  <div className="p-2">
                    <form onSubmit={handleSubmit}>
                      <div className="mb-3">
                        <label className="form-label" htmlFor="user_id">Username</label>
                        <input type="text" className="form-control" value={username} onChange={handleUsernameChange} name="user_id" id="user_id" placeholder="Enter Username" />
                      </div>
                      <div className="text-center mt-4">
                        <button className="btn btn-secondary w-100" disabled={!username || isLoading} type="submit">Send OTP</button>
                      </div>
                    </form>
                  </div>
                  <div className="mt-4 text-center">
                    <p className="mb-0">Wait, I remember my password... <NavLink to={'/'} className="fw-semibold text-primary text-decoration-underline"> Click here </NavLink> </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(ForgotPassword);